import {useEffect, useRef, useState} from "react";
import {useModal} from "@/context/ModalContext";
import {sendOrderForm} from "@/services/forms.service";
import {trackEvent} from "@/utils/analytics";
import PhoneInput from "@components/forms/PhoneInput";
import {validatePhone} from "@/utils/validatePhone";

export default function OrderModal() {
	const {isOpen, close} = useModal();
	const [status, setStatus] = useState("idle");
	const [phone, setPhone] = useState("");
	const [phoneError, setPhoneError] = useState("");
	const modalRef = useRef(null);

	useEffect(() => {
		if (isOpen && modalRef.current) {
			modalRef.current.scrollTop = 0;
		}
	}, [isOpen]);

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) close();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const err = phone ? validatePhone(phone) : "Введіть номер телефону";
		if (err) {
			setPhoneError(err);
			return;
		}
		setPhoneError("");
		setStatus("loading");

		const fd = new FormData(e.target);
		try {
			await sendOrderForm({
				name: fd.get("name"),
				phone,
				type: fd.get("type"),
				material: fd.get("material"),
				comment: fd.get("comment"),
			});
			setStatus("success");
			trackEvent("form_submit", { form_name: "order_form" });
			e.target.reset();
			setPhone("");
			setTimeout(() => {
				setStatus("idle");
				close();
			}, 3000);
		} catch {
			setStatus("error");
			setTimeout(() => setStatus("idle"), 4000);
		}
	};

	return (
		<div className={`modal-overlay${isOpen ? " open" : ""}`} onClick={handleOverlayClick}>
			<div className="modal" ref={modalRef}>
				<button className="modal-close" onClick={close} aria-label="Закрити">✕</button>
				<p className="modal-kicker">Залиште заявку</p>
				<h3 className="modal-title">Розрахунок вартості</h3>
				<p className="modal-sub">Безкоштовна консультація &bull; Відповідь за 30 хв</p>

				<form onSubmit={handleSubmit} className="contacts-form-fields">
					<div className="contacts-form-row">
						<div className="contacts-form-field">
							<label className="contacts-field-label" htmlFor="om-name">Ваше ім&apos;я</label>
							<input
								id="om-name"
								name="name"
								type="text"
								className="contacts-field-input"
								placeholder="Іван Петренко"
								required
							/>
						</div>
						<div className="contacts-form-field">
							<label className="contacts-field-label" htmlFor="om-phone">Телефон</label>
							<PhoneInput
								id="om-phone"
								value={phone}
								onChange={(v) => {
									const next = v ?? "";
									setPhone(next);
									setPhoneError(validatePhone(next));
								}}
								className={phoneError ? "is-invalid" : ""}
								aria-invalid={Boolean(phoneError)}
							/>
							{phoneError && <span className="field-error">{phoneError}</span>}
						</div>
					</div>

					{/* <div className="contacts-form-field">
						<label className="contacts-field-label" htmlFor="om-type">Тип пам&apos;ятника</label>
						<select id="om-type" name="type" className="contacts-field-select" defaultValue="">
							<option value="" disabled>Оберіть тип</option>
							<option>Гранітний одинарний</option>
							<option>Гранітний подвійний</option>
							<option>З хрестом</option>
							<option>Дитячий пам&apos;ятник</option>
							<option>Меморіальна плита</option>
							<option>Індивідуальний дизайн</option>
						</select>
					</div> */}

					{/* <div className="contacts-form-field">
						<label className="contacts-field-label" htmlFor="om-material">Матеріал</label>
						<select id="om-material" name="material" className="contacts-field-select" defaultValue="">
							<option value="" disabled>Оберіть матеріал</option>
							<option>Чорний граніт</option>
							<option>Сірий граніт</option>
							<option>Червоний граніт</option>
							<option>Мармур</option>
						</select>
					</div> */}

					<div className="contacts-form-field contacts-form-field--grow">
						<label className="contacts-field-label" htmlFor="om-comment">Коментар</label>
						<textarea
							id="om-comment"
							name="comment"
							className="contacts-field-textarea"
							placeholder="Додаткові побажання..."
							rows="5"
						/>
					</div>

					<button
						type="submit"
						className="contacts-submit-btn"
						disabled={status === "loading" || status === "success"}
					>
						{status === "loading" && "Відправляємо..."}
						{status === "success" && "✓ Заявку відправлено!"}
						{status === "error" && "Помилка. Спробуйте ще раз"}
						{status === "idle" && "Відправити заявку"}
					</button>
					<p className="contacts-form-hint" style={{textAlign: "center"}}>
						Натискаючи кнопку, ви погоджуєтесь з обробкою персональних даних
					</p>
				</form>
			</div>
		</div>
	);
}
